var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 114,
    viewBox: "0 0 112 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 114,
    rx: 10,
    fill: "#FFEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1266_8760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 80.3438C54.025 80.3438 53.5 79.7953 53.5 79.125V49.875C53.5 49.2047 54.025 48.6562 54.6667 48.6562H66.3333V54.75C66.3333 56.0982 67.376 57.1875 68.6667 57.1875H74.5V79.125C74.5 79.7953 73.975 80.3438 73.3333 80.3438H54.6667ZM54.6667 45C52.0927 45 50 47.1861 50 49.875V79.125C50 81.8139 52.0927 84 54.6667 84H73.3333C75.9073 84 78 81.8139 78 79.125V56.7686C78 55.4736 77.5115 54.232 76.6365 53.318L70.0302 46.4244C69.1552 45.5104 67.974 45 66.7344 45H54.6667ZM58.75 64.5C57.7802 64.5 57 65.315 57 66.3281C57 67.3412 57.7802 68.1562 58.75 68.1562H69.25C70.2198 68.1562 71 67.3412 71 66.3281C71 65.315 70.2198 64.5 69.25 64.5H58.75ZM58.75 71.8125C57.7802 71.8125 57 72.6275 57 73.6406C57 74.6537 57.7802 75.4688 58.75 75.4688H69.25C70.2198 75.4688 71 74.6537 71 73.6406C71 72.6275 70.2198 71.8125 69.25 71.8125H58.75Z",
    fill: "#F17070"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.3846,
    y: 40.667,
    width: 19.3846,
    height: 19.5,
    fill: "#FFEBEB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1266_8760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 32.8125C36.2676 32.8125 30.8125 38.2676 30.8125 45V47.3438C30.8125 48.123 30.1855 48.75 29.4062 48.75C28.627 48.75 28 48.123 28 47.3438V45C28 36.7148 34.7148 30 43 30C51.2852 30 58 36.7148 58 45V53.4434C58 56.291 55.6914 58.5996 52.8379 58.5996L46.375 58.5938C45.8887 59.4316 44.9805 60 43.9375 60H42.0625C40.5098 60 39.25 58.7402 39.25 57.1875C39.25 55.6348 40.5098 54.375 42.0625 54.375H43.9375C44.9805 54.375 45.8887 54.9434 46.375 55.7812L52.8438 55.7871C54.1387 55.7871 55.1875 54.7383 55.1875 53.4434V45C55.1875 38.2676 49.7324 32.8125 43 32.8125ZM36.4375 42.1875H37.375C38.4121 42.1875 39.25 43.0254 39.25 44.0625V50.625C39.25 51.6621 38.4121 52.5 37.375 52.5H36.4375C34.3691 52.5 32.6875 50.8184 32.6875 48.75V45.9375C32.6875 43.8691 34.3691 42.1875 36.4375 42.1875ZM49.5625 42.1875C51.6309 42.1875 53.3125 43.8691 53.3125 45.9375V48.75C53.3125 50.8184 51.6309 52.5 49.5625 52.5H48.625C47.5879 52.5 46.75 51.6621 46.75 50.625V44.0625C46.75 43.0254 47.5879 42.1875 48.625 42.1875H49.5625Z",
    fill: "#F17070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1266_8760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 39,
    fill: "white",
    transform: "translate(50 45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1266_8760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(28 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationSupport);
export default __webpack_public_path__ + "static/media/application_support.e1b2076e78cfd0bd4a6e7907c9853fd8.svg";
export { ForwardRef as ReactComponent };